import React from 'react'
import { Grid } from '@mui/material'
import {
  DocumentScanner,
  History,
  Flaky
} from '@mui/icons-material';
import { headerCells } from './data'
import { styles } from '../styles'
import {BookingTransactionType} from "../../constants/securspace-constants";
import NoMatchingInvoicesFound from '../../NoMatchingInvoicesFound';
import InfoCard from "../../deprecatedUikit/InfoCard/InfoCard";


const BuyerInvoicesTable = ({
  invoices,
  loading,
  locationId,
  invoiceNumber,
  bookingNumber,
  invoiceType,
  sortBy,
  expandedItems,
  handleToggle
}) => {


  const viewInvoice = (item) => {
    if (item) {
      window.open(`/buyer-invoice/${item.refundForTransactionNumber || item.transactionNumber}`);
    }
  }

  const viewUsage = (item) => {
    let queryParams;
    if ([BookingTransactionType.OVERAGE_CHARGE, BookingTransactionType.DAILY_OVERAGE_CHARGE].includes(item.transactionType)) {
      queryParams = new URLSearchParams({overageInvoiceNumber: item.transactionNumber}).toString();
    } else {
      queryParams = new URLSearchParams(
        {initBookingNumber: item.bookingNumber, initStartDate: item.startDate, initEndDate: item.endDate})
        .toString();
    }
    window.open(`/reports/space-usage?${queryParams}`);
  }

  const viewApproveDisputeInvoice = (item) => {
    if (item) {
      //window.open(`/buyer-invoice/${item?.transactionNumber}`);
      window.open(`/buyer/service-fee/${item.transactionId}`);
    }
  }

  const actionItems = [
    {
      icon: <DocumentScanner fontSize='medium' color='primary' />,
      label: "View Invoice",
      onClick: viewInvoice
    },
    {
      icon: <History fontSize='medium' color='primary' />,
      label: "View Usage",
      onClick: viewUsage
    }
  ];

  const conditionalActionsItems = invoices?.map((invoice, index) => {
        if (invoice.transactionType === 'Service Charge') {
            return {
                id: index,
                icon: <Flaky fontSize='medium' color='primary' />,
                label: "Approve/Decline Invoice",
                onClick: viewApproveDisputeInvoice
            };
        } else {
            return null;
        }
    }).filter(item => item !== null);

  return (
    <Grid item mb={4} container flexDirection={'column'} sx={{
      ...(!invoices.length && !loading) && styles.container,
      '& .css-13i4rnv-MuiGrid-root': {
          wordWrap:'normal',
      },
      '@media(max-width: 39.28em)': {
        '& .css-13i4rnv-MuiGrid-root': {
          top:'4%',
        }
      }

    }}>
      {(!invoices.length && !loading) ? (
        <Grid sx={styles.showMessage}>
          {
            invoiceNumber || locationId || bookingNumber || invoiceType || sortBy ? (
              <NoMatchingInvoicesFound
                message="No matching records found."
              />
            ) : (
              <NoMatchingInvoicesFound
                message="No input selected, To view results kindly select the data above"
              />
            )
          }
        </Grid>
      ) : (
        invoices.map((invoice, index) => (
          <InfoCard
            headCells={headerCells}
            data={invoice}
            actionItems={actionItems}
            conditionalActionItems={conditionalActionsItems}
            inx={index}
            key={invoice.transactionId}
            handleToggle={handleToggle}
            collapse={expandedItems[invoice.transactionId]}
          />
        ))
      )}
    </Grid>
  )
}

export default BuyerInvoicesTable
